<template>
  <nav class="navbar-top" role="navigation">
    <div class="navbar-header">
      <button type="button" class="navbar-toggle pull-right" data-toggle="collapse" data-target=".sidebar-collapse">
        <font-awesome :icon="['fas' ,'bars']"/> Menu
      </button>
      <div class="navbar-brand">
        <router-link to="/">
          <img src="~assets/img/logo/white.svg" class="img-responsive" alt="" />
        </router-link>
      </div>
    </div><!-- /.navbar-header -->

    <div class="nav-top">
      <ul class="nav navbar-left">
        <li class="tooltip-sidebar-toggle">
          <a href="#" id="sidebar-toggle">
            <font-awesome :icon="['fas' ,'bars']"/>
          </a>
        </li>
      </ul>

      <ul class="nav navbar-right">
        <li class="dropdown">
          <a href="#" class="dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
            <font-awesome :icon="['fas' ,'user']"/> <font-awesome :icon="['fas' ,'caret-down']"/>
          </a>
          <ul class="dropdown-menu dropdown-user">
            <li>
              <server-link to="profile">
                <i class="fa fa-user"></i> My Profile
              </server-link>
            </li>
            <li class="divider"></li>
            <li>
              <server-link class="logout_open" to="logout" data-popup-ordinal="0" id="open_59027522">
                <font-awesome :icon="['fas' ,'sign-out']"/> Logout
                <strong>{{$user.first_name}} {{$user.surname}}</strong>
              </server-link>
            </li>
          </ul>
          <!-- /.dropdown-menu -->
        </li>
      </ul><!-- /.nav -->
    </div><!-- /.nav-top -->
  </nav><!-- /.navbar-top -->
</template>

<script>
import $ from 'jquery'

export default {
  mounted () {
    $('#sidebar-toggle').click(function (e) {
      e.preventDefault()
      $('.navbar-side').toggleClass('collapsed')
      $('#page-wrapper').toggleClass('collapsed')
      $('.navbar-band').toggleClass('hidden')
    })

    if (this.isTablet()) {
      $('#sidebar-toggle').click()
    }
  },

  watch: {
    '$route.path' (newPath, oldPath) {
      if (this.isTablet()) {
        $('#sidebar-toggle').click()
      }
    }
  },

  computed: {
    sizes () {
      return {
        ipad: { width: 1024, height: 768 },
        ipadPro: { width: 1366, height: 1024 }
      }
    }
  },

  methods: {
    isTablet () {
      const screen = {
        width: $(window).width(),
        height: $(window).height()
      }

      const sizes = this.sizes
      let test = false
      Object.keys(sizes).forEach(function (device) {
        if (
          (screen.width <= sizes[device].width && screen.height <= sizes[device].height) ||
          (screen.width <= sizes[device].height && screen.height <= sizes[device].width)
        ) {
          test = true
        }
      })

      return test
    }
  }
}
</script>
